import { render, staticRenderFns } from "./ClassThemesList.vue?vue&type=template&id=72025f5e&"
import script from "./ClassThemesList.vue?vue&type=script&lang=js&"
export * from "./ClassThemesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports